// extracted by mini-css-extract-plugin
export default {"printFOIA":"Inspect-module__printFOIA--__iuJ","printReview":"Inspect-module__printReview--z4ocU","reviewContent":"Inspect-module__reviewContent--JcEii"};